import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';

import { AsyncJobConfig } from '../../async-job-view.types';

@Injectable()
export class BrockmeyerCampaignDeleteAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.BrockmeyerCampaignDelete;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public readonly translations = {
    title: {
      success: 'app.async_jobs.brockmeyer_campaign_delete.title.success.one',
      progress: 'app.async_jobs.brockmeyer_campaign_delete.title.progress.one',
    },
  };
}
